<script lang="ts">
	//Services
	import { format } from '../../../../services/i18n';
	import { localReq, postReq } from '../../../../services/http';
	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Helpers
	import { get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	//Types
	import type { InputClickEvent } from '../../../../types/InputClickEvent';
	//Design system components
	import { Toggle, toast } from '@Shelly/shelly-design-system';

	export let device;

	const id = real_id(device.id);
	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore;
	let loading = false;
	let reverse = $settingsStore[device.category + 's'][device.channel].swap;
	let local_ip = get_local_ip(id);

	const setReverse = async (e: InputClickEvent) => {
		let res;
		loading = true;
		reverse = e.target.checked;
		if (local_ip) {
			res = await localReq(device, `${local_ip}/settings/roller/0`, 'post', {
				swap: reverse ? 1 : 0,
			});
		} else {
			res = await postReq(`/device/relay/roller/settings/swap`, {
				id: id,
				roller_id: device.channel,
				swap: reverse,
			});
		}

		if (res.isok) {
			await res.data;

			settings[device.category + 's'][device.channel].swap = reverse;
			devices_settings.update_devices_settings(device.id, settings);

			toast.open({
				type: 'success',
				title: $format('reverse_directions_scc_toast', {
					default: `Directions was swapped.`,
				}),
			});
		} else {
			toast.open({ type: 'danger', title: $format('error_global') });
			reverse = !reverse;
		}
		loading = false;
	};
</script>

<Toggle disabled={loading} size="m" checked={reverse} on:click={setReverse} id="toggle-q4yvqzv">
	{$format('reverse_directions_enable') ||
		'Enable if the directions of movement do not match the directions in the interface.'}
</Toggle>
